import React from 'react';
import { FlexGrid, TypographyBody, Styler, BellIcon, Notification } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { SearchAlternativeDatesButton } from '../HotelSearchNoResult/SearchAlternativeDatesButton';
import { LookForHotelOnlyButton } from '../HotelSearchNoResult/LookForHotelOnlyButton';
export function HotelStopSellMessage({ message, title, isHolidaySearch = false, stackButtons = false, onOpenSearchUnit, }) {
    const { resourceStrings: { NOTAVL, NOHOTELDESC }, } = useGlobalContext();
    return (React.createElement("div", null,
        React.createElement(Styler, { mb: 4 },
            React.createElement(Notification, { color: "warning", icon: React.createElement(BellIcon, null) },
                React.createElement(FlexGrid, { container: true, flexWrap: "nowrap", alignItems: "flex-start", spacing: 4 },
                    React.createElement(FlexGrid, null,
                        React.createElement(TypographyBody, { weight: "bold", "data-id": "no-matches-heading" }, title || NOTAVL),
                        React.createElement("p", { "data-id": "no-matches-message" }, message || NOHOTELDESC))))),
        React.createElement(FlexGrid, { container: true, spacing: 3 },
            React.createElement(FlexGrid, { xs: 12, m: stackButtons ? 12 : 'auto' },
                React.createElement(SearchAlternativeDatesButton, { onOpenSearchUnit: onOpenSearchUnit, fullWidth: true })),
            isHolidaySearch && (React.createElement(FlexGrid, { xs: 12, m: stackButtons ? 12 : 'auto' },
                React.createElement(LookForHotelOnlyButton, { fullWidth: true }))))));
}
